import { VideoTrack } from '@livekit/components-react';
import styled from '@rsos/theme/styled';

interface StyledVideoTrackProps {
  isBlurred: boolean;
}

export const StyledVideoTrack = styled(
  VideoTrack,
).withConfig<StyledVideoTrackProps>({
  shouldForwardProp: prop => prop !== 'isBlurred',
})`
  width: 100%;
  /* max width/height only for fullscreen when we're in a portal: */
  max-width: 100vw;
  max-height: 100vh;
  ${props => props.isBlurred && 'filter: blur(7.5px);'}
`;

export const StyledDispatcherLiveVideoWrapper = styled.div<{
  isFullscreen: boolean;
}>`
  min-height: 360px;
  background-color: ${({ theme }) => theme.colors.background};
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ isFullscreen }) =>
    isFullscreen
      ? `
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    /* z-index gets us above the top toolbar which is in the same stacking context we are (document root) */
    z-index: 3;
  `
      : ''}
`;

export const StyledVideoPlaceholder = styled.div`
  // 350px map card width times 9:16 proportions
  min-height: 568px;
`;
